module.exports = __webpack_public_path__ + "public/media/digital-left.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/digital-left.png
// module id = ./images/services/digital-left.png
// module chunks = 0